import React, { useEffect, useState } from "react";
import * as Mui from "@mui/material";
import dayjs from "dayjs";
import { showToast } from "services/utils/Status";
import { defaultAllSelection } from "services/constants";
import { useFetch } from "services/hooks/useFetch";
import { useSelector } from "react-redux";
import { customGetAPI } from "services/utils/CustomAPI";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { CustomAutoCompleteWithLogo } from "components/CustomComponents/CustomAutoCompleteWithLogo";
import { CustomButton } from "components/CustomComponents";
import { ListView } from "./ListView";
import { LeaveCredit } from "./LeaveCredit";
import { themes, statusType, headerMessage } from "services/constants";
import { MoveLeaveGroup } from "./MoveLeaveGroup";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { checkEditorPermission } from "services/utils/HelperFunction";
// import { customAPI } from "services/utils/CustomAPI";
export const Assignment = () => {
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [showAutoAssignPopup, setShowAutoAssignPopup] = useState(false);
  //AutoComplete
  const [companyArray, setCompanyArray] = useState([]);
  const [leaveGroupArray, setLeaveGroupArray] = useState([]);
  const [userArray, setUserArry] = useState([]);
  //Filter
  const [companyName, setCompanyName] = useState("");
  const [companyNameId, setCompanyNameId] = useState(null);
  const [leaveGroupName, setLeaveGroupName] = useState("");
  const [leaveGroupNameId, setLeaveGroupNameId] = useState(defaultAllSelection);
  const [userName, setuserName] = useState("");
  const [userNameId, setUserNameId] = useState(defaultAllSelection);
  //Filter
  const [masterDataUserDetails, setMasterDataUserDetails] = useState([]);
  const [moveScreen, setMoveScreen] = useState(false);
  const [updateAllDetails, setUpdateAllDetails] = useState(true);
  const [fetchUserDetails, setFetchUserDetails] = useState(true);
  const [manualLeaveCredit, setManualLeaveCredit] = useState(false);
  const [showCreditDetails, setShowCreditDetils] = useState(false);
  const [selectedArray, setSelectedArray] = useState([]);
  const [selectedDetails, setSelectedDetails] = useState([]);
  const [expendRowId, setExpendRowId] = useState(0);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [statusName, setStatusName] = useState("Active");
  const [showAutoCompleteAvathar, setShowAutoCompleteAvathar] = useState(false);
  const [calculateInnerWidth, setCalculateInnerWidth] = useState(
    window.innerWidth < 1400
  );

  useEffect(() => {
    const handleResize = () => {
      setCalculateInnerWidth(window.innerWidth < 1400);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const today = dayjs();

  const { domain, userScreenAccess, userDetails, topbarCompanyId } = useSelector(
    (state) => state.tokenReducer
  );

  const { result: userDetail, loading: userLoadder } = useFetch(
    `${domain}new_user_details/?company_id=${topbarCompanyId}`
  );
  const { result: companyDetails, loading: companyloader } = useFetch(
    `${domain}get-active-company/`
  );
  const { result: leaveGroup, loading: loader } = useFetch(
    `${domain}leave-group-new/`
  );

  useEffect(() => {
    const getAllFilterDetails = async () => {
      const allLeaveGroup = {
        id: defaultAllSelection,
        label: "All Leave Group",
        name: "All Leave Group",
      };
      const allUserDetails = {
        id: defaultAllSelection,
        label: "All Users",
        user_name: "All Users",
      };
      setCompanyArray(companyDetails);
      setLeaveGroupArray([allLeaveGroup, ...leaveGroup]);
      setUserArry([allUserDetails, ...userDetail]);
      setCompanyName(companyDetails.find((company) => String(company.id) === String(topbarCompanyId))?.companyname || "");
      setLeaveGroupName(allLeaveGroup);
      setuserName(allUserDetails);
      setUpdateAllDetails(false);
    };
    if (updateAllDetails && !userLoadder && !companyloader && !loader) {
      getAllFilterDetails();
    }
  });

  const handleCompanyName = (event, data) => {
    if (data) {
      setCompanyNameId(data?.id);
      setCompanyName(data?.label);
      setFetchUserDetails(true);
    }
  };

  const handleLeaveGroupName = (event, data) => {
    if (data) {
      setLeaveGroupNameId(data?.id);
      setLeaveGroupName(data?.label);
      setFetchUserDetails(true);
    }
  };

  useEffect(() => {
    const fetchIndividualUserDetails = async () => {
      const res = await customGetAPI(
        `${domain}user-leave-balance/?leavegroup_id=${
          selectedArray[0]?.leave_group_id
        }&user_id=${
          selectedArray?.length > 1 ? String(defaultAllSelection) : selectedArray[0]?.user_id
        }`
      );
      if (res.ok) {
        setSelectedDetails(res?.responseDetails);
      }
    };
    if (
      selectedArray[0]?.leave_group_id &&
      selectedArray[0]?.user_id &&
      showCreditDetails
    ) {
      fetchIndividualUserDetails();
    }
  }, [domain, selectedArray, showCreditDetails]);

  useEffect(() => {
    setCompanyNameId(topbarCompanyId);
    setFetchUserDetails(true);
  }, [topbarCompanyId]);

  useEffect(() => {
    const fetchAllUsers = async () => {
      setLoading(true);
      const res = await customGetAPI(
        `${domain}leavegroup-assignment/?selected_user_id=${userNameId}&user_id=${userDetails?.id}&company_id=${companyNameId}&leave_group_id=${leaveGroupNameId}&status=${statusName}`
      );
      if (res.ok) {
        setMasterDataUserDetails(res?.responseDetails);
        setLoading(false);
      }
    };
    if (fetchUserDetails && companyNameId && String(companyNameId) !== String(defaultAllSelection)) {
      fetchAllUsers();
      setFetchUserDetails(false);
    }
  }, [
    companyNameId,
    domain,
    fetchUserDetails,
    leaveGroupNameId,
    statusName,
    userDetail.id,
    userDetails?.id,
    userNameId
  ]);

  const handleUserDetailsUpdate = (event, data) => {
    if (data) {
      setUserNameId(data?.id);
      setuserName(data);
      setFetchUserDetails(true);
      setShowAutoCompleteAvathar(false);
    } else {
      setShowAutoCompleteAvathar(true);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickTop = (event) => {
    setAnchorEl1(event.currentTarget);
  };

  const autoLeaveCredit = async () => {
    function getCSRFToken() {
      return document.cookie
        .split("; ")
        .find((row) => row.startsWith("csrftoken="))
        ?.split("=")[1];
    }

    const isLocalhost =
      window.location.hostname === "localhost" ||
      window.location.hostname.startsWith("127.");
    let response;
    setButtonLoader(true);
    if (!isLocalhost) {
      await fetch(`${domain}csrf/`, { credentials: "include" });
      response = await fetch(`${domain}leave-auto-credit/`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": getCSRFToken(),
        },
        body: JSON.stringify({
          date: today.format("YYYY-MM-DD"),
          isautocredit: true,
        }),
      });
    } else {
      response = await fetch(`${domain}leave-auto-credit/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          date: today.format("YYYY-MM-DD"),
          isautocredit: true,
        }),
      });
    }
    if (response.ok) {
      setShowAutoAssignPopup(false);
      showToast("success", response.message);
      setFetchUserDetails(true);
      setExpendRowId(0);
      setButtonLoader(false);
    }
  };

  const handleStatusName = (event, data) => {
    if (data) {
      setStatusName(data?.name);
      setFetchUserDetails(true);
    } else {
      setStatusName("");
    }
  };

  return moveScreen ? (
    <React.Fragment>
      <MoveLeaveGroup
        setMoveScreen={setMoveScreen}
        setFetchUserDetails={setFetchUserDetails}
        companyDetails={companyDetails}
      />
    </React.Fragment>
  ) : showCreditDetails ? (
    <React.Fragment>
      <LeaveCredit
        selectedArray={selectedArray}
        setShowCreditDetils={setShowCreditDetils}
        setSelectedArray={setSelectedArray}
        selectedDetails={selectedDetails}
        setSelectedDetails={setSelectedDetails}
        setFetchUserDetails={setFetchUserDetails}
      />
    </React.Fragment>
  ) : (
    <React.Fragment>
      {headerMessage(
        "Assign Leave Group",
        "Assign leave groups to employees",
      )}
      <Mui.Grid container sx={{ paddingLeft: 1 }}>
        <Mui.Grid
          xs={calculateInnerWidth ? 9 : 10.2}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            paddingTop: 2,
            paddingLeft: 3,
          }}
        >
          <CustomButton
            actionFuntion={() => {
              setShowFilter(!showFilter);
              setManualLeaveCredit(false);
              setSelectedArray([]);
            }}
            actionName="Filter"
            typeName="button"
          />{" "}
        </Mui.Grid>
        <Mui.Grid
          xs={calculateInnerWidth ? 6 : 1.8}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            paddingTop: 2,
          }}
        >
          {!showFilter ? (
            <Mui.Grid container>
              {selectedArray?.length === 0 && statusName !== "Inactive" ? (
                <Mui.Button
                  sx={{
                    background: themes.primaryButton,
                    textTransform: "capitalize",
                    "&:hover": {
                      backgroundColor: themes.primaryButton,
                    },
                    color: themes.headLine,
                    fontWeight: "bold",
                  }}
                  size="medium"
                  variant="contained"
                  onClick={(event) => {
                    handleClickTop(event);
                    setSelectedArray([]);
                  }}
                >
                  Credit Leave
                </Mui.Button>
              ) : null}
              <Mui.Menu
                anchorEl={anchorEl1}
                open={Boolean(anchorEl1)}
                onClose={() => {
                  setAnchorEl1(null);
                }}
                elevation={1}
                transformOrigin={{
                  horizontal: "center",
                  vertical: "top",
                }}
                anchorOrigin={{
                  horizontal: "center",
                  vertical: "bottom",
                }}
              >
                <Mui.MenuItem
                  sx={{ width: "100%" }}
                  onClick={() => {
                    if (
                      checkEditorPermission(
                        userScreenAccess?.module_details,
                        "LMS",
                        "Assignment"
                      )
                    ) {
                      setAnchorEl1(null);
                      setShowAutoAssignPopup(true);
                    } else {
                      showToast(
                        "error",
                        "Access denied: You are not authorized to allow auto leave credit"
                      );
                    }
                  }}
                >
                  Auto Leave Credit
                </Mui.MenuItem>
                <Mui.MenuItem
                  sx={{ width: "100%" }}
                  onClick={() => {
                    if (
                      checkEditorPermission(
                        userScreenAccess?.module_details,
                        "LMS",
                        "Assignment"
                      )
                    ) {
                      setAnchorEl1(null);
                      setManualLeaveCredit(true);
                    } else {
                      showToast(
                        "error",
                        "Access denied: You are not authorized to allow manual leave credit"
                      );
                    }
                  }}
                >
                  Manual Leave Credit
                </Mui.MenuItem>
              </Mui.Menu>
              &nbsp;&nbsp;
              {selectedArray?.length === 0 && statusName !== "Inactive" ? (
                <CustomButton
                  actionFuntion={() => {
                    if (
                      checkEditorPermission(
                        userScreenAccess?.module_details,
                        "LMS",
                        "Assignment"
                      )
                    ) {
                      setMoveScreen(true);
                    } else {
                      showToast(
                        "error",
                        "Access denied: You are not authorized to move user"
                      );
                    }
                  }}
                  actionName="Move"
                  typeName="button"
                />
              ) : null}
            </Mui.Grid>
          ) : null}
        </Mui.Grid>
      </Mui.Grid>
      {showFilter ? (
        <Mui.Grid container sx={{ paddingLeft: 3.5 }}>
          <Mui.Grid xs={2} sx={{ padding: 0.5 }}>
            <Mui.Typography>Company</Mui.Typography>
            <CustomAutoComplete
              dataList={companyArray.map((obj) => ({
                ...obj,
                label: obj.companyname,
              }))}
              selectedValue={companyName}
              updateDataFunction={handleCompanyName}
              placeHolder="Select the company name"
            />
          </Mui.Grid>
          <Mui.Grid xs={2} sx={{ padding: 0.5 }}>
            <Mui.Typography>Leave Group</Mui.Typography>
            <CustomAutoComplete
              dataList={leaveGroupArray.map((obj) => ({
                ...obj,
                label: obj.name,
              }))}
              selectedValue={leaveGroupName}
              updateDataFunction={handleLeaveGroupName}
              placeHolder="Select the leave Group"
            />
          </Mui.Grid>
          <Mui.Grid xs={2} sx={{ padding: 0.5 }}>
            <Mui.Typography>Employee Name</Mui.Typography>
            <CustomAutoCompleteWithLogo
              dataList={userArray.map((obj) => ({
                ...obj,
                label: obj.user_name,
                image: obj?.image_url,
              }))}
              selectedValue={userName}
              updateDataFunction={handleUserDetailsUpdate}
              placeHolder="Select the employee name"
              showAvathar={showAutoCompleteAvathar}
              setShowAutoCompleteAvathar={setShowAutoCompleteAvathar}
            />
          </Mui.Grid>
          <Mui.Grid xs={2} sx={{ padding: 0.5 }}>
            <Mui.Typography>Status</Mui.Typography>
            <CustomAutoComplete
              dataList={statusType.map((obj) => ({
                ...obj,
                label: obj.name,
              }))}
              selectedValue={statusName}
              updateDataFunction={handleStatusName}
              placeHolder="Select the status name"
            />
          </Mui.Grid>
          {/* <Mui.Grid xs={calculateInnerWidth ? 0.5 : 4.2}></Mui.Grid> */}
          <Mui.Grid xs={2.2}></Mui.Grid>
          <Mui.Grid xs={calculateInnerWidth ? 3 : 1.8} sx={{ paddingTop: 3.5 }}>
            {selectedArray?.length === 0 && statusName !== "Inactive" ? (
              <Mui.Button
                sx={{
                  background: themes.primaryButton,
                  textTransform: "capitalize",
                  "&:hover": {
                    backgroundColor: themes.primaryButton,
                  },
                  color: themes.headLine,
                  fontWeight: "bold",
                }}
                variant="contained"
                size="medium"
                onClick={(event) => {
                  handleClick(event);
                  setSelectedArray([]);
                }}
              >
                Credit Leave
              </Mui.Button>
            ) : null}
            <Mui.Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => {
                setAnchorEl(null);
              }}
              elevation={1}
              transformOrigin={{
                horizontal: "center",
                vertical: "top",
              }}
              anchorOrigin={{
                horizontal: "center",
                vertical: "bottom",
              }}
            >
              <Mui.MenuItem
                sx={{ width: "100%" }}
                onClick={() => {
                  if (
                    checkEditorPermission(
                      userScreenAccess?.module_details,
                      "LMS",
                      "Assignment"
                    )
                  ) {
                    setAnchorEl(null);
                    setShowAutoAssignPopup(true);
                  } else {
                    showToast(
                      "error",
                      "Access denied: You are not authorized to allow aoto leave credit"
                    );
                  }
                }}
              >
                Auto Leave Credit
              </Mui.MenuItem>
              <Mui.MenuItem
                sx={{ width: "100%" }}
                onClick={() => {
                  if (
                    checkEditorPermission(
                      userScreenAccess?.module_details,
                      "LMS",
                      "Assignment"
                    )
                  ) {
                    setAnchorEl(null);
                    setManualLeaveCredit(true);
                  } else {
                    showToast(
                      "error",
                      "Access denied: You are not authorized to allow manual leave credit"
                    );
                  }
                }}
              >
                Manual Leave Credit
              </Mui.MenuItem>
            </Mui.Menu>
            &nbsp;&nbsp;
            {selectedArray?.length === 0 && statusName !== "Inactive" ? (
              <CustomButton
                actionFuntion={() => {
                  if (
                    checkEditorPermission(
                      userScreenAccess?.module_details,
                      "LMS",
                      "Assignment"
                    )
                  ) {
                    setMoveScreen(true);
                  } else {
                    showToast(
                      "error",
                      "Access denied: You are not authorized to move user"
                    );
                  }
                }}
                actionName="Move"
                typeName="button"
              />
            ) : null}
          </Mui.Grid>
        </Mui.Grid>
      ) : null}

      <ListView
        masterDataUserDetails={masterDataUserDetails}
        manualLeaveCredit={manualLeaveCredit}
        setFetchUserDetails={setFetchUserDetails}
        leaveGroupName={leaveGroupName}
        showFilter={showFilter}
        loading={loading}
        showCreditDetails={showCreditDetails}
        setShowCreditDetils={setShowCreditDetils}
        selectedArray={selectedArray}
        setSelectedArray={setSelectedArray}
        expendRowId={expendRowId}
        setExpendRowId={setExpendRowId}
        statusName={statusName}
      />

      <GlobalDialogBox
        open={showAutoAssignPopup}
        handleCloseDialog={() => {
          setShowAutoAssignPopup(false);
        }}
        title={"Auto Leave Assign"}
        minWidth={500}
      >
        <Mui.Typography sx={{ fontWeight: "bold", padding: 1, fontSize: 18 }}>
          The auto credit functionality will recredit the leaves for the current
          schedule . Would you like to continue ?
        </Mui.Typography>
        <Mui.Grid
          container
          sx={{
            paddingTop: 1,

            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <CustomButton
            actionFuntion={() => {
              setShowAutoAssignPopup(false);
            }}
            actionName="No"
            typeName="button"
          />{" "}
          &nbsp;
          <CustomButton
            actionFuntion={() => {
              autoLeaveCredit();
            }}
            actionName="Yes"
            typeName="submit"
            disableAction={buttonLoader}
          />
        </Mui.Grid>
      </GlobalDialogBox>
    </React.Fragment>
  );
};
